import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=35783bbf&scoped=true&"
import script from "./Spin.vue?vue&type=script&lang=js&"
export * from "./Spin.vue?vue&type=script&lang=js&"
import style0 from "./Spin.vue?vue&type=style&index=0&id=35783bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35783bbf",
  null
  
)

export default component.exports